import React from 'react';
export default (props) => {
  let icon = '';

  if (props.loading) icon = 'spinner ev-spin wizard-loader';
  else icon = props.icon;

  return (
    <div>
      <i className={`fas fa-${icon} ${props.iconClass}`} />
    </div>
  );
};
